import React from 'react';
import styled from 'styled-components';

import { DEFAULT_COMPANY_LOGO } from '../../common/constants';
import GlintsPicture from './GlintsPicture';
import { GlintsPictureProps } from './interfaces';

interface Props extends Omit<GlintsPictureProps, 'name'> {
  logo?: string;
  fit?: boolean;
}

const FittedImage = styled.div<{ fit: boolean }>`
  display: block;
  width: 100%;
  height: 100%;
  line-height: 0;
  flex-shrink: 0;
  min-width: 0;
  min-height: 0;

  img {
    display: block;
    ${({ fit }) =>
      fit
        ? `
    width: 100%;
    height: 100%;
    object-fit: contain;
    `
        : ''}
  }
`;

const CompanyLogo: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  logo,
  size,
  sizes,
  breakpoints,
  fit,
  ...otherProps
}) => {
  const shouldFit = fit ?? size !== undefined;
  return (
    <FittedImage className={className} fit={shouldFit}>
      <GlintsPicture
        className={className}
        name={logo ? logo : DEFAULT_COMPANY_LOGO}
        assetType="company-logo"
        fallbackAssetType="company-logo"
        fallback={DEFAULT_COMPANY_LOGO}
        size={size}
        sizes={sizes ?? (size !== undefined ? `${size}px` : '100px')}
        breakpoints={breakpoints}
        {...otherProps}
      />
    </FittedImage>
  );
};

export default CompanyLogo;
